<app-header></app-header>

<div class="page-title-area page-title-style-two item-rights">
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li><a routerLink="/">Home</a></li>
                <li>Legislatie</li>
            </ul>
            <h2>Legislatie</h2>
        </div>
    </div>
</div>

<div class="about-area ptb-100">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <h3>Baza legala</h3>
                <ul>
                    <li>
                        <a href="http://www.suub.ro/wp-content/uploads/2011/08/Lege544_2001.pdf" target="_blank" >Lege 544_2001</a>

                    </li>
                    <li>
                        <a href="http://www.suub.ro/wp-content/uploads/2011/08/Lege544_2001_norme.pdf" target="_blank">Norme de aplicare pentru Legea 544/2001</a>
                    </li>
                    <li>
                        <a href="http://www.suub.ro/wp-content/uploads/2011/08/20110214_ContestareAccesInf544.pdf" target="_blank">Modalităţile de contestare a deciziei autorităţii sau a instituţiei publice în situaţia în care persoana se consideră vătămată în privinţa dreptului de acces la informaţiile de interes public solicitate</a>
                    </li>
                    <li>
                        <a href="http://www.suub.ro/2015/09/24/ordin-nr-9642013-privind-informatiile-de-interes-public-ce-pot-fi-comunicate-si-informatiile-exceptate-de-la-comunicare-la-nivelul-ministerului-sanatatii/" target="_blank">Ordin nr. 964/2013 privind informatiile de interes public ce pot fi comunicate si informatiile exceptate de la comunicare, la nivelul Ministerului Sanatatii</a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>

<app-footer></app-footer>
